export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('asm:areas.table.name'),
  },
  {
    id: 'criticity',
    type: 'select',
    value: t('asm:areas.table.criticality'),
    render: (value) => {
      const criticityColors = {
        '1': '#4caf50',
        '2': '#8bc34a',
        '3': '#ff9800',
        '4': '#ff5722',
        '5': '#f44336'
      };
      const color = criticityColors[value];
      if (!color) return value;

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: color
            }}
          />
          {t('asm:criticality.' + value)}
        </div>
      );
    }
  },
  {
    id: 'description',
    type: 'text',
    value: t('asm:areas.table.description')
  },
  {
    id: 'user',
    type: 'text',
    value: t('asm:areas.table.responsible'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
    minWidth: '140px'
  },
]
